export default [
	{  //采购单列表
		path: 'order',
		name: 'm_purchase_order',
		meta: {
			templateManage: {
				workType: 39,
				print: 'b_out_sourcing_printtemplate',
				export: 'b_out_sourcing_exporttemplate'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/purchase/purchase_order_list.vue')
	},
	{  //采购单明细列表
		path: 'product',
		name: 'm_purchase_product',
		meta: {
			templateManage: {
				workType: 40,
				print: 'b_purchase_product_printtemplate',
				export: 'b_purchase_product_exporttemplate'
			}
		},
		component: () => import('@/pages/purchase/purchase_product_list.vue')
	}
];